/**
 *
 * usage:
 * import GtmService from 'static/script/app/ui/google-tagmanager-service';
 * GtmService.trackEvent("zorro", { marvel: false, black: true })
 */

class GoogleTagManagerService {
    push(payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }

    /**
     * tracks a google analytics event
     * @param {string} category ga category
     * @param {string} action ga action what happens, ie: "Filter box - open/close"
     * @param {string} label ga label what the value of the action was, ie "close"
     * @param {integer} [value] ga interger value of the action.
     */
    trackAction(category, action, label, value = 0) {
        this.push({
            event: 'trackEvent',
            eventCategory: category || '',
            eventAction: action || '',
            eventLabel: label || '',
            eventValue: value || '0',
            eventNonInteractive: false
        });
    }

    /**
     * google tag manager event. Note: if you want to send google analytics events use trackAction instead
     * @param {string} eventName
     * @param {object} [event] data
     */
    trackGtmEvent(eventName, data = {}) {
        this.push({
            event: eventName,
            ...data
        });
    }

    /**
     * Track a pageview. Use this script in SPA's to make sure that analytics gets pageview information.
     * This creates a virtual page view since google analytics by default doesn't track changes to url via
     * push state.
     */
    trackPageView() {
        this.trackGtmEvent('trackPageview');
    }
}

export default new GoogleTagManagerService();
